'use strict';

var boardingOptionsTrackingUtils = require('../../tracking/boarding_options');

module.exports = Odigeo.View.extend({
    init: function() {
        this.initSegmentNames();
    },
    selectors: {
        handBaggageSummaryWrapper: '.hand_baggage_summary_wrapper',
        baggageInfo: '.baggage_info',
        baggageFeeHintContainer: '.baggage_fee_hint_container',
        baggageFeeHintText: '.baggage_fee_hint_text',
    },
    show: function() {
        this.$cachedSelectors.handBaggageSummaryWrapper.removeClass('odf-hidden');
        this.renderBaggage(this.model.getData());

        this.initTooltip();
    },
    renderBaggage: function(data) {
        this.$cachedSelectors.baggageInfo.html(this.getTemplate(data));
    },
    getTemplate: function(data) {
        const template = data.hasStops ? this.templates.section : this.templates.segment;

        return template(Odigeo._.extend(data, {
            segmentNames: this.getKeysPerTripType(this.model.getTripType()),
            product: this.model.getProduct(),
        }));
    },
    initSegmentNames: function() {
        this.segmentNames = {
            ONE_WAY: [
                this.keys.flightOutbound,
            ],
            ROUND_TRIP: [
                this.keys.flightOutbound,
                this.keys.flightInbound,
            ],
            MULTIPLE_DESTINATIONS: [
                this.keys.flightFirst,
                this.keys.flightSecond,
                this.keys.flightThird,
                this.keys.flightFourth,
                this.keys.flightFifth,
                this.keys.flightSixth,
            ],
        };
    },
    getKeysPerTripType: function(type) {
        return this.segmentNames[type] || [];
    },
    initTooltip: function() {
        this.$cachedSelectors.baggageFeeHintContainer.addClass('odf-hidden');

        if (this.model.get('fee') > 0) {
            this.initTooltipData();
        }
    },
    initTooltipData: function() {
        let hint;
        if (Odigeo.AB.isTravelFusionCabinBagsDesktop) {
            const hintKey = this.keys.cabinbags_aside_fee_hint;
            hint = Odigeo.Utils.replaceCmsKeyArgs(hintKey, this.getFormattedFeePrice());
        } else {
            hint = Odigeo.Utils.replaceCmsKeyArgs(this.model.getTranslation('hint'), this.getFormattedFeePrice());
        }
        const data = this.model.get('trackingData');

        if (!Odigeo._.isEmpty(hint)) {
            this.$cachedSelectors.baggageFeeHintContainer.removeClass('odf-hidden');
            this.$cachedSelectors.baggageFeeHintText.html(hint);

            Odigeo.UIElements.hint.enhance(
                Odigeo.History.getPageNameFromFragment(),
                this.$cachedSelectors.baggageFeeHintContainer, {
                    events: {
                        tap: true,
                    },
                    googleAnalyticsOnOpen: this.getTrackingData(data),
                });
        }
    },
    getFormattedFeePrice: function() {
        return Odigeo.Utils.formatCurrency(this.model.get('fee'));
    },
    getTrackingData: function(data) {
        return {
            type: 'trackEvent',
            data: {
                action: 'sidebar',
                label: [
                    'cabin_bag_sidebar_info-',
                    boardingOptionsTrackingUtils.getTypeTrackingConstant(this.model.getSelectedType()),
                    '_legs:',
                    data.totalNumber,
                    '-',
                    data.carrierNumber,
                    '_carrier:',
                    this.model.getCarrier(),
                ].join(''),
            },
        };
    },
});
